import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Course from "../pages/course/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/music-production-course",
    element: <Course />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
